import { ReactNode } from "react";
import { Link } from "react-router-dom";

type ButtonProps = {
  children: ReactNode;
  href?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean; // ✅ TAMBAH
  bgClass?: string;
  hoverBgClass?: string;
  textClass?: string;
  hoverTextClass?: string;
  borderClass?: string;
  hoverBorderClass?: string;
  rounded?: string;
  padding?: string;
  className?: string;
  withArrow?: boolean;
};


export default function Button({
  children,
  href,
  onClick,
  type = "button",
  disabled = false,
  bgClass = "bg-primary",
  hoverBgClass = "hover:bg-secondary",
  textClass = "text-font-primary",
  hoverTextClass = "hover:text-font-secondary",
  borderClass = "border-transparent",
  hoverBorderClass = "",
  rounded = "rounded-lg",
  padding = "px-4 py-2",
  className = "",
  withArrow = false,
}: ButtonProps) {
  const base = `transition-colors duration-300 inline-flex items-center justify-center border gap-2 ${padding} ${rounded}`;

  const disabledClass = "opacity-60 cursor-not-allowed";

  const classes = `
    ${base}
    ${disabled ? disabledClass : `${bgClass} ${hoverBgClass} ${textClass} ${hoverTextClass} ${borderClass} ${hoverBorderClass}`}
    ${className}
  `;

  const content = (
    <>
      {children}
      {withArrow && <p className="ml-1 text-lg">→</p>}
    </>
  );

  // ⛔ Link tidak boleh disabled
  if (href) {
    return (
      <Link
        to={href}
        className={`${classes} ${disabled ? "pointer-events-none" : ""}`}
      >
        {content}
      </Link>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled} // ✅ penting
      className={classes}
    >
      {content}
    </button>
  );
}
